import React from 'react';
import { IconProps } from './RightDropdownArrow';

export const HeaderSocialTwitter = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="37"
			viewBox="0 0 36 37"
			fill="none"
			className="social_icon twitter"
		>
			<path
				d="M26.0575 5.83203H30.3552L20.966 16.5633L32.0117 31.1661H23.363L16.5891 22.3096L8.83812 31.1661H4.53783L14.5805 19.6878L3.98438 5.83203H12.8526L18.9757 13.9272L26.0575 5.83203ZM24.5491 28.5937H26.9305L11.5586 8.2693H9.00312L24.5491 28.5937Z"
				fill={props.color}
			/>
		</svg>
	);
};

export const HeaderSocialDiscord = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="37"
			viewBox="0 0 36 37"
			fill="none"
			className="social_icon discord"
		>
			<path
				d="M28.3963 8.96192C26.4842 8.08457 24.4337 7.43818 22.2899 7.06796C22.2508 7.06081 22.2118 7.07867 22.1917 7.11438C21.928 7.5834 21.6359 8.19527 21.4314 8.6762C19.1255 8.33099 16.8315 8.33099 14.5729 8.6762C14.3683 8.18458 14.0656 7.5834 13.8007 7.11438C13.7806 7.07986 13.7416 7.06201 13.7026 7.06796C11.5599 7.43699 9.50945 8.08339 7.59617 8.96192C7.57961 8.96906 7.56541 8.98098 7.55599 8.99644C3.66674 14.8069 2.60131 20.4745 3.12398 26.0719C3.12634 26.0993 3.14171 26.1255 3.163 26.1421C5.72901 28.0265 8.21463 29.1706 10.6541 29.9288C10.6931 29.9408 10.7345 29.9265 10.7594 29.8943C11.3364 29.1063 11.8508 28.2754 12.2918 27.4016C12.3179 27.3504 12.293 27.2897 12.2398 27.2694C11.4239 26.9599 10.647 26.5826 9.89966 26.154C9.84055 26.1195 9.83582 26.035 9.8902 25.9945C10.0475 25.8766 10.2048 25.754 10.3549 25.6302C10.3821 25.6076 10.42 25.6028 10.4519 25.6171C15.3616 27.8587 20.6769 27.8587 25.5287 25.6171C25.5606 25.6017 25.5985 25.6064 25.6268 25.629C25.7771 25.7528 25.9343 25.8766 26.0928 25.9945C26.1472 26.035 26.1436 26.1195 26.0845 26.154C25.3372 26.5909 24.5602 26.9599 23.7431 27.2683C23.6899 27.2885 23.6663 27.3504 23.6923 27.4016C24.1428 28.2742 24.6572 29.1051 25.2236 29.8931C25.2473 29.9265 25.2898 29.9408 25.3289 29.9288C27.7802 29.1706 30.2658 28.0265 32.8318 26.1421C32.8543 26.1255 32.8685 26.1005 32.8708 26.0731C33.4963 19.6019 31.8231 13.9808 28.4353 8.99763C28.427 8.98098 28.4128 8.96906 28.3963 8.96192ZM13.025 22.6637C11.5469 22.6637 10.3289 21.3066 10.3289 19.64C10.3289 17.9734 11.5233 16.6164 13.025 16.6164C14.5386 16.6164 15.7448 17.9853 15.7211 19.64C15.7211 21.3066 14.5268 22.6637 13.025 22.6637ZM22.9934 22.6637C21.5153 22.6637 20.2974 21.3066 20.2974 19.64C20.2974 17.9734 21.4917 16.6164 22.9934 16.6164C24.507 16.6164 25.7132 17.9853 25.6895 19.64C25.6895 21.3066 24.507 22.6637 22.9934 22.6637Z"
				fill={props.color}
			/>
		</svg>
	);
};

export const HeaderSocialYoutube = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="37"
			viewBox="0 0 36 37"
			fill="none"
			className="social_icon youtube"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.6881 8.62176C30.9782 8.96835 31.9987 9.9889 32.3453 11.279C32.9807 13.6282 33 18.4998 33 18.4998C33 18.4998 33 23.3907 32.3646 25.7206C32.018 27.0107 30.9974 28.0313 29.7073 28.3779C27.3774 29.0133 18 29.0133 18 29.0133C18 29.0133 8.62259 29.0133 6.29268 28.3779C5.00257 28.0313 3.98203 27.0107 3.63543 25.7206C3 23.3714 3 18.4998 3 18.4998C3 18.4998 3 13.6282 3.61617 11.2983C3.96277 10.0082 4.98331 8.98761 6.27343 8.64102C8.60334 8.00558 17.9807 7.98633 17.9807 7.98633C17.9807 7.98633 27.3582 7.98633 29.6881 8.62176ZM22.7754 18.4998L14.9961 23.0056V13.994L22.7754 18.4998Z"
				fill={props.color}
			/>
		</svg>
	);
};

export const HeaderSocialTelegram = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="37"
			viewBox="0 0 36 37"
			fill="none"
			className="social_icon telegram"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.211 10.905C17.8568 11.8842 13.1518 13.9108 6.09602 16.9849C4.95027 17.4406 4.35007 17.8863 4.29543 18.3222C4.20309 19.0587 5.1255 19.3488 6.38158 19.7437C6.55244 19.7975 6.72947 19.8531 6.91096 19.9121C8.14676 20.3138 9.80911 20.7838 10.6733 20.8025C11.4572 20.8194 12.3321 20.4962 13.2981 19.8329C19.8906 15.3828 23.2936 13.1335 23.5073 13.085C23.658 13.0508 23.8669 13.0078 24.0084 13.1336C24.1499 13.2594 24.136 13.4976 24.121 13.5615C24.0296 13.9511 20.4089 17.3173 18.5351 19.0593C17.9509 19.6024 17.5366 19.9876 17.4519 20.0756C17.2621 20.2726 17.0688 20.4591 16.8829 20.6382C15.7348 21.745 14.8739 22.575 16.9306 23.9303C17.9189 24.5816 18.7098 25.1202 19.4988 25.6575C20.3605 26.2443 21.22 26.8296 22.332 27.5586C22.6153 27.7443 22.8859 27.9372 23.1494 28.125C24.1522 28.84 25.0532 29.4822 26.1662 29.3798C26.8129 29.3203 27.481 28.7122 27.8203 26.8984C28.6221 22.6119 30.1982 13.3244 30.5624 9.49727C30.5943 9.16196 30.5542 8.73283 30.5219 8.54445C30.4897 8.35608 30.4223 8.08768 30.1775 7.88899C29.8875 7.65369 29.4398 7.60407 29.2396 7.60759C28.3293 7.62363 26.9326 8.10928 20.211 10.905Z"
				fill={props.color}
			/>
		</svg>
	);
};